import { render, staticRenderFns } from "./ProductBlock.vue?vue&type=template&id=745902c2"
import script from "./ProductBlock.vue?vue&type=script&lang=js"
export * from "./ProductBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports